export const frBE = {
  app: {
    categories: {
      convectors: 'Convecteurs',
      decorative: 'Design',
      electric: 'Électriques',
      panels: 'Panneaux',
      towel: 'Sèche-serviettes',
    },
    categoryLabel: 'Catégorie',
    categoryPlaceholder: 'Sélectionnez une catégorie',
    errorCategories: 'Échec du chargement des catégories.',
    errorPanels: 'Échec du chargement des radiateurs.',
    loadingCategories: 'Chargement des catégories...',
    loadingPanels: 'Chargement des radiateurs...',
    panelLabel: 'Radiateurs',
    panelPlaceholder: 'Sélectionnez un radiateur',
    titles: {
      convectors: 'Calculateur pour convecteurs',
      decorative: 'Calculateur pour radiateurs design',
      electric: 'Calculateur pour radiateurs électriques',
      panels: 'Calculateur pour radiateurs panneaux',
      towel: 'Calculateur pour sèches-serviettes',
    },
  },
  calc: {
    actionButton: 'Afficher les produits calculés',
    boost: 'Mode boost',
    calculateRequiredButton: 'Calculer la puissance requise',
    calculating: 'Calcul en cours...',
    comfort: 'Mode confort',
    downloadLabel: 'Télécharger les données ({count})',
    emptyResults: 'Aucun résultat pour le moment.',
    errorMatch: 'Échec du calcul des résultats.',
    errorTypes: 'Échec du chargement des types de radiateurs.',
    flowTemp: 'Température aller C°',
    height: 'Hauteur',
    length: 'Longueur',
    loadingTypes: 'Chargement des types de radiateurs...',
    modeLabel: 'Mode',
    modes: {
      cooling: 'Refroidissement',
      heating: 'Chauffage',
    },
    radiatorType: 'Type de radiateur',
    requiredWatts: 'Puissance requise (W)',
    resultsMessage: '{count} produits disponibles pour les options sélectionnées.',
    returnTemp: 'Température retour C°',
    roomTemp: 'Température ambiante C°',
    selectAllLabel: 'Sélectionner tous les produits',
    selectItemLabel: 'Sélectionnez le produit à télécharger',
    selectPanel: 'Sélectionnez un radiateur pour calculer.',
    standby: 'Mode veille',
    tableHeaders: {
      calculatedWattage: 'Puissance',
      co2Equivalent: 'Équivalent CO2 par kg de matériau',
      depth: 'Profondeur [mm]',
      description: 'Description du produit',
      dop: 'DoP',
      eudop: 'EU DoP',
      height: 'Hauteur [mm]',
      itemId: 'Code produit',
      length: 'Longueur [mm]',
      waterContent: 'Contenu en eau',
      weight: 'Poids',
    },
    title: 'Calculs',
    tolerance: 'Tolérance',
    typeCooling: 'Refroidissement',
    typeGroupLabel: 'Type',
    typeHeating: 'Chauffage',
  },
  existingRadiator: {
    description:
      "Ce calculateur est fourni à titre indicatif uniquement. Consultez toujours un installateur professionnel pour le calcul exact avant d'acheter le radiateur.",
    height: 'Hauteur du radiateur',
    length: 'Longueur du radiateur',
    resultLabelTemplate: 'Puissance thermique requise, calculée à {temp} température système',
    select: 'Sélectionner',
    temperature: 'Température du système',
    type: 'Type de radiateur',
  },
  matrixCalc: {
    axisHeight: 'Hauteur (mm)',
    axisLength: 'Longueur (mm)',
    axisType: 'Type',
    calculateButton: 'Calculate',
    displayLabel: 'Affichage',
    exportExcel: 'Exporter en Excel',
    exportPdf: 'Exporter en PDF',
    print: 'Imprimer',
    hideOutOfRange: 'Masquer les articles hors plage',
    showAll: 'Tout afficher',
    loading: 'Loading...',
    lockHeight: 'Hauteur',
    lockLabel: 'Verrouiller la dimension',
    lockLength: 'Longueur',
    lockType: 'Type',
    noData: 'Select a radiator and click Calculate to view the matrix.',
    noItem: '—',
    noType: '—',
    targetOutput: 'Target output (W)',
    title: 'Matrix Calculator',
    tolerance: 'Tolerance (%)',
  },
  roomCalc: {
    actionButton: 'Calculer',
    clearButton: 'Tout effacer',
    fields: {
      ceilingHeight: 'Hauteur sous plafond',
      doorInsulation: 'Isolation des portes',
      floorInsulation: 'Isolation du sol',
      glazingArea: 'Surface vitrée',
      glazingMode: 'Surface vitrée',
      glazingQuality: 'Qualité du vitrage',
      length: 'Longueur',
      outerWalls: 'Murs extérieurs',
      projectedDesignTemp: 'Température extérieure de base',
      roofInsulation: 'Isolation du toit',
      roomArea: 'Surface de la pièce',
      roomFloor: 'Étage',
      roomInsulation: 'Isolation de la pièce',
      roomPreset: 'Type de pièce',
      roomTemperature: 'Température ambiante',
      roomType: 'Type de pièce',
      uncertaintyFactor: "Facteur d'incertitude",
      ventilation: 'Niveau de ventilation',
      wallInsulation: 'Isolation des murs',
      width: 'Largeur',
      windConditions: 'Conditions de vent',
      windowInsulation: 'Isolation des fenêtres',
    },
    intro:
      'Calculez les déperditions thermiques de la pièce pour sélectionner le bon produit dans la gamme de radiateurs Radson.',
    options: {
      glazing: {
        m2: 'm²',
        percent: '%',
      },
      glazingBands: {
        high: 'Plus de 20%',
        low: 'Moins de 10%',
        mid: '10-20%',
      },
      glazingValue: {
        above_20: 'Plus de 20%',
        below_10: 'Moins de 10%',
        from_10_to_20: 'De 10% à 20%',
        no_windows: 'Sans fenêtres',
      },
      insulationValue: {
        good: 'Bonne',
        medium: 'Moyenne',
        poor: 'Mauvaise',
        very_good: 'Très bonne',
      },
      qualityValue: {
        modern_excellent: 'Moderne, excellente efficacité énergétique',
        modern_good: 'Moderne, bonne efficacité énergétique',
        old_poor: 'Ancien, très mauvaise efficacité énergétique',
        traditional_medium: 'Traditionnel, efficacité énergétique moyenne',
      },
      roomValue: {
        bathroom_24: 'Salle de bain (24°C)',
        bedroom_20: 'Cuisine, Bureau (20°C)',
        garage_12: 'Garage (12°C)',
        livingroom_22: 'Séjour (22°C)',
        storage_16: 'Éspace de stockage, Hall (16°C)',
        extra_1: 'Chambre (18°C)',
      },
      select: 'Sélectionner',
      storeyValue: {
        ground_multi: 'Rez-de-chaussée avec plafond au-dessus',
        ground_single: 'Rez-de-chaussée avec toit au-dessus',
        interim: 'Étage avec plafond au-dessus',
        top_multi: 'Étage avec toit au-dessus',
      },
      temp: {
        climate_zone_1: '-5 °C',
        climate_zone_2: '-6 °C',
        climate_zone_3: '-7 °C',
        climate_zone_4: '-8 °C',
        climate_zone_5: '-9 °C',
        climate_zone_6: '-10 °C',
        climate_zone_7: '-11 °C',
        climate_zone_8: '-12 °C',
      },
      windInfluence: {
        normal: 'Normal',
        strong: 'Fort',
        weak: 'Faible',
      },
    },
    roomPresets: {
      bathroom: 'Salle de bain',
      bedroom: 'Chambre',
      garage: 'Garage',
      kitchen: 'Cuisine',
      living: 'Salon',
      storage: 'Stockage',
    },
    sections: {
      dimensions: 'Dimensions de la pièce',
      insulation: 'Isolation',
      placement: 'Emplacement',
      result: 'Résultat',
      temps: 'Températures',
      ventilation: 'Ventilation',
    },
    title: 'Calculateur de déperditions thermiques',
    units: {
      celsius: 'C°',
      meter: 'm',
      percent: '%',
      squareMeter: 'm²',
      watts: 'W',
    },
    useButton: 'Utiliser',
  },
  slider: {
    from: 'De',
    to: 'À',
    value: 'Valeur',
  },
}
